export function animateConfig( $animateProvider ) {
  $animateProvider.classNameFilter(/angular-animate/);
}

animateConfig.$inject = [ '$animateProvider' ];



// WEBPACK FOOTER //
// ./app/config/animate.config.ts